/**
 * Auto-vaporisateur - Version ultra optimisée avec API AJAX Cart Shopify
 * 
 * Cette version synchronise les vaporisateurs avec les parfums:
 * - Ajoute le bon vaporisateur pour chaque parfum
 * - Ajuste la quantité si le client modifie la quantité de parfum
 * - Utilise l'API AJAX Cart de Shopify pour des performances maximales
 * - Affiche une animation discrète pendant le processus de synchronisation
 */
  
(function() {
  // Configuration
  const config = {
    vaporisateurHandle: 'vaporisateur-10-ml-offert',
    variantSizes: ['50 ml', '50ml', '100 ml', '100ml'],
    minSyncInterval: 50,
    checkoutBlockDelay: 300,
    batchSize: 10,
    loadingClass: "vaporisateur-loading",
    loadingColor: "#AF8756", // Couleur de l'animation (à ajuster selon votre thème)
    parfumsEligibles: ['vaporisateur-10-ml-offert'] // Nouvelle propriété
  };

  // État global
  let isSynchronizing = false;
  let lastSyncTime = 0;
  let syncTimeoutId = null;
  let vaporisateursNeedSync = false;
  let vaporisateurProduct = null;
  let loadingElement = null;
  
  // Cache des variantes
  const variantCache = {};
  
  // Injecter le CSS pour l'animation de chargement
  function injectLoadingCSS() {
    const css = `
      .${config.loadingClass}-container {
        position: relative;
        width: 100%;
        text-align: center;
        padding: 10px 0;
      }
      
      .${config.loadingClass} {
        display: inline-block;
        width: 24px;
        height: 24px;
        border: 2px solid rgba(175, 135, 86, 0.2);
        border-radius: 50%;
        border-top-color: ${config.loadingColor};
        animation: ${config.loadingClass}-spin 0.8s linear infinite;
      }
      
      @keyframes ${config.loadingClass}-spin {
        to { transform: rotate(360deg); }
      }
      
      .cart-drawer__footer .${config.loadingClass}-container,
      form[action="/cart"] .${config.loadingClass}-container {
        margin: 10px auto;
      }
    `;
    
    const styleElement = document.createElement('style');
    styleElement.textContent = css;
    document.head.appendChild(styleElement);
  }
  
  // Afficher une animation pendant la synchronisation
  function showSyncAnimation() {
    // Supprimer toute animation existante
    removeSyncAnimation();
    
    // Créer le conteneur et l'animation
    loadingElement = document.createElement('div');
    loadingElement.className = `${config.loadingClass}-container`;
    
    const spinner = document.createElement('div');
    spinner.className = config.loadingClass;
    
    loadingElement.appendChild(spinner);
    
    // Trouver l'emplacement où injecter l'animation
    const cartLocations = [
      document.querySelector('.cart-drawer__footer'), // Drawer cart typique
      document.querySelector('.cart__footer'),        // Page panier
      document.querySelector('.cart-drawer'),         // Alternative drawer
      document.querySelector('.drawer__inner'),       // Autre drawer possible
      document.querySelector('#CartDrawer'),          // Dawn theme
      document.querySelector('#mini-cart'),           // Certains thèmes
      document.querySelector('.mini-cart')            // Autres thèmes
    ];
    
    // Insérer l'animation dans le premier emplacement valide
    for (const location of cartLocations) {
      if (location) {
        location.insertAdjacentElement('afterbegin', loadingElement);
        break;
      }
    }
  }
  
  // Supprimer l'animation de synchronisation avec un délai facultatif
  function removeSyncAnimation(delay = 0) {
    if (delay > 0) {
      setTimeout(() => {
        removeAnimationImmediately();
      }, delay);
    } else {
      removeAnimationImmediately();
    }
  }
  
  // Supprimer l'animation immédiatement (fonction interne)
  function removeAnimationImmediately() {
    // NOUVEAU: Forcer la suppression de toutes les animations, même s'il y en a plusieurs
    try {
      if (loadingElement) {
        loadingElement.remove();
        loadingElement = null;
      }
      
      // Supprimer aussi tous les éléments qui pourraient rester
      const oldLoadings = document.querySelectorAll(`.${config.loadingClass}-container`);
      oldLoadings.forEach(el => el.remove());
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'animation de chargement:', error);
      // Dernière tentative pour nettoyer tous les éléments de chargement
      try {
        document.querySelectorAll('[class*="-loading-container"]').forEach(el => el.remove());
      } catch (e) {
        // Silence
      }
    }
  }
  
  // API Shopify AJAX Cart optimisée - Wrappers
  const ShopifyCart = {
    // Obtenir l'état actuel du panier
    get: async function() {
      try {
        showSyncAnimation(); // Afficher l'animation à chaque opération du panier
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error(`Erreur cart.js: ${response.status}`);
        return await response.json();
      } catch (error) {
        removeSyncAnimation(300); // Délai pour que l'animation ne disparaisse pas trop brusquement
        return null;
      }
    },
    
    // Mettre à jour des quantités dans le panier
    update: async function(updates) {
      try {
        showSyncAnimation(); // Afficher l'animation à chaque opération du panier
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!response.ok) throw new Error(`Erreur update: ${response.status}`);
        return await response.json();
      } catch (error) {
        removeSyncAnimation(300); // Délai pour que l'animation ne disparaisse pas trop brusquement
        return null;
      }
    },
    
    // Ajouter un élément au panier
    add: async function(item) {
      try {
        showSyncAnimation(); // Afficher l'animation à chaque opération du panier
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item)
        });
        if (!response.ok) throw new Error(`Erreur add: ${response.status}`);
        return await response.json();
      } catch (error) {
        removeSyncAnimation(300); // Délai pour que l'animation ne disparaisse pas trop brusquement
        return null;
      }
    },
    
    // Ajouter plusieurs éléments au panier
    addItems: async function(items) {
      try {
        showSyncAnimation(); // Afficher l'animation à chaque opération du panier
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) throw new Error(`Erreur addItems: ${response.status}`);
        return await response.json();
      } catch (error) {
        removeSyncAnimation(300); // Délai pour que l'animation ne disparaisse pas trop brusquement
        return null;
      }
    },
    
    // Changer le panier (utilise la nouvelle API cart/change.js)
    change: async function(item) {
      try {
        showSyncAnimation(); // Afficher l'animation à chaque opération du panier
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item)
        });
        if (!response.ok) throw new Error(`Erreur change: ${response.status}`);
        return await response.json();
      } catch (error) {
        removeSyncAnimation(300); // Délai pour que l'animation ne disparaisse pas trop brusquement
        return null;
      }
    },
    
    // Récupérer des informations sur un produit
    getProduct: async function(handle) {
      try {
        if (handle.startsWith('/')) handle = handle.slice(1);
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error(`Erreur produit: ${response.status}`);
        return await response.json();
      } catch (error) {
        return null;
      }
    }
  };

  // Récupérer et cacher les données du vaporisateur
  async function loadVaporisateurProduct() {
    if (vaporisateurProduct) return vaporisateurProduct;
    
    try {
      vaporisateurProduct = await ShopifyCart.getProduct(config.vaporisateurHandle);
      
      if (vaporisateurProduct) {
      } else {
        console.error(`Le produit '${config.vaporisateurHandle}' n'existe pas dans la boutique.`);
      }
      
      return vaporisateurProduct;
    } catch (error) {
      return null;
    }
  }
  
  // Fonction pour trouver la variante du vaporisateur correspondant au parfum
  function findMatchingVaporisateurVariant(parfumTitle, vaporisateurProduct) {
    if (!vaporisateurProduct || !vaporisateurProduct.variants) return null;
    
    // Vérifier d'abord dans le cache
    if (variantCache[parfumTitle]) {
      return variantCache[parfumTitle];
    }
    
    // Extraire le nom du parfum sans la taille
    const parfumName = parfumTitle.split(' - ')[0].trim();
    
    // Fonction pour normaliser les titres (suppression des accents et minuscules)
    function normalizeText(text) {
      return text.toLowerCase()
        .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Supprime les accents
    }
    
    // Normaliser le nom du parfum pour la recherche
    const normalizedParfumName = normalizeText(parfumName);
    
    // Cas spécial pour 'ananda nectar'
    if (normalizedParfumName === 'ananda nectar') {
      for (let i = 0; i < vaporisateurProduct.variants.length; i++) {
        if (normalizeText(vaporisateurProduct.variants[i].title).includes('ananda') && 
            vaporisateurProduct.variants[i].available) {
          variantCache[parfumTitle] = vaporisateurProduct.variants[i];
          return vaporisateurProduct.variants[i];
        }
      }
    }
    
    // Cas spécial pour 'ananda royal mango'
    if (normalizedParfumName === 'ananda royal mango') {
      for (let i = 0; i < vaporisateurProduct.variants.length; i++) {
        if (
          normalizeText(vaporisateurProduct.variants[i].title).includes('royal mango') &&
          vaporisateurProduct.variants[i].available
        ) {
          variantCache[parfumTitle] = vaporisateurProduct.variants[i];
          return vaporisateurProduct.variants[i];
        }
      }
    }
    
    // Recherche optimisée de variante correspondante avec normalisation
    let variant = null;
    for (let i = 0; i < vaporisateurProduct.variants.length; i++) {
      const normalizedVariantTitle = normalizeText(vaporisateurProduct.variants[i].title);
      if (normalizedVariantTitle.includes(normalizedParfumName) && 
          vaporisateurProduct.variants[i].available) {
        variant = vaporisateurProduct.variants[i];
        break;
      }
    }
    
    // Si pas de correspondance exacte, prendre la première disponible
    if (!variant) {
      for (let i = 0; i < vaporisateurProduct.variants.length; i++) {
        if (vaporisateurProduct.variants[i].available) {
          variant = vaporisateurProduct.variants[i];
          break;
        }
      }
      
      // Si toujours rien, prendre la première
      if (!variant && vaporisateurProduct.variants.length > 0) {
        variant = vaporisateurProduct.variants[0];
      }
    }
    
    // Mettre en cache et retourner
    if (variant) {
      variantCache[parfumTitle] = variant;
    }
    
    return variant;
  }

  // Synchroniser le panier pour s'assurer que les vaporisateurs correspondent aux parfums
  async function synchronizeCart() {
    // Éviter les appels multiples rapprochés
    const now = Date.now();
    if (isSynchronizing || now - lastSyncTime < config.minSyncInterval) {
      vaporisateursNeedSync = true;
      return;
    }

    isSynchronizing = true;
    lastSyncTime = now;
    vaporisateursNeedSync = false;
    
    
    try {
      // Bloquer temporairement le checkout pendant la synchronisation
      blockCheckoutButtons();
      
      // Charger le vaporisateur s'il n'est pas déjà chargé
      if (!vaporisateurProduct) {
        vaporisateurProduct = await loadVaporisateurProduct();
        if (!vaporisateurProduct) {
          isSynchronizing = false;
          unblockCheckoutButtons();
          removeSyncAnimation();
          return;
        }
      }
      
      // Récupérer le panier
      const cart = await ShopifyCart.get();
      if (!cart || !cart.items || cart.items.length === 0) {
        isSynchronizing = false;
        unblockCheckoutButtons();
        removeSyncAnimation();
        return;
      }
      
      
      // Analyser le panier
      const parfums = [];
      const vaporisateurs = [];
      
      // Analyse en une seule boucle - plus rapide
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        
        if (item.handle === config.vaporisateurHandle) {
          vaporisateurs.push({
            key: item.key,
            quantity: item.quantity,
            variant_id: item.variant_id,
            variant_title: item.variant_title,
            line: i + 1  // ligne du panier (1-indexed)
          });
        } else {
          // Vérifier si c'est un parfum éligible
          const variantTitle = item.variant_title || '';
          let isParfum = false;
          
          // Exclure les produits contenant 'Mist' ou 'Brume' dans leur nom (insensible à la casse)
          const productTitle = (item.product_title || '').toLowerCase();
          if (productTitle.includes('mist') || productTitle.includes('brume')) {
            continue;
          }
          
          for (let j = 0; j < config.variantSizes.length; j++) {
            if (variantTitle.includes(config.variantSizes[j])) {
              isParfum = true;
              break;
            }
          }
          
          if (isParfum) {
            const isLargeSize = variantTitle.includes('100');
            const vaporisateursNeeded = isLargeSize ? 1 : 0;
            
            parfums.push({
              title: item.product_title,
              variant_title: variantTitle,
              quantity: item.quantity,
              vaporisateursNeeded: vaporisateursNeeded * item.quantity
            });
          }
        }
      }
      
      // Si aucun parfum, supprimer tous les vaporisateurs
      if (parfums.length === 0 && vaporisateurs.length > 0) {
        
        // Utiliser l'API cart/change.js (plus rapide)
        for (const vaporisateur of vaporisateurs) {
          await ShopifyCart.change({
            line: vaporisateur.line,
            quantity: 0
          });
        }
        
        refreshCartUI();
        isSynchronizing = false;
        unblockCheckoutButtons();
        return;
      }
      
      // Si aucun parfum, rien à faire
      if (parfums.length === 0) {
        isSynchronizing = false;
        unblockCheckoutButtons();
        removeSyncAnimation(300);
        return;
      }
      
      // Calculer le nombre total de vaporisateurs nécessaires
      let totalVaporisateursNeeded = 0;
      const vaporisateursParVariant = {};
      
      // 1. Calculer combien de vaporisateurs nécessaires pour chaque variante
      for (const parfum of parfums) {
        const matchingVariant = findMatchingVaporisateurVariant(parfum.title, vaporisateurProduct);
        if (!matchingVariant) continue;
        
        if (!vaporisateursParVariant[matchingVariant.id]) {
          vaporisateursParVariant[matchingVariant.id] = {
            variant: matchingVariant,
            quantityNeeded: parfum.vaporisateursNeeded,
            existing: null
          };
        } else {
          vaporisateursParVariant[matchingVariant.id].quantityNeeded += parfum.vaporisateursNeeded;
        }
        
        totalVaporisateursNeeded += parfum.vaporisateursNeeded;
      }
      
      // 2. Vérifier les vaporisateurs existants
      for (const vaporisateur of vaporisateurs) {
        if (vaporisateursParVariant[vaporisateur.variant_id]) {
          vaporisateursParVariant[vaporisateur.variant_id].existing = vaporisateur;
        }
      }
      
      
      // 3. Effectuer les mises à jour nécessaires
      const variantIds = Object.keys(vaporisateursParVariant);
      let cartModified = false;
      
      // Mettre à jour ou ajouter des vaporisateurs
      for (const variantId of variantIds) {
        const info = vaporisateursParVariant[variantId];
        
        if (info.existing) {
          // Mettre à jour si la quantité est différente
          if (info.existing.quantity !== info.quantityNeeded) {
            
            await ShopifyCart.change({
              id: info.existing.key,
              quantity: info.quantityNeeded
            });
            
            cartModified = true;
          }
        } else {
          // Ajouter un nouveau vaporisateur
          
          const result = await ShopifyCart.add({
            id: parseInt(variantId),
            quantity: info.quantityNeeded,
            properties: {
              _vaporisateur_offert: "Offert avec votre parfum"
            }
          });
          
          if (result) {
            cartModified = true;
          }
        }
      }
      
      // 4. Supprimer les vaporisateurs qui ne correspondent à aucun parfum
      for (const vaporisateur of vaporisateurs) {
        // Si ce vaporisateur n'est pas dans notre liste, le supprimer
        if (!variantIds.includes(String(vaporisateur.variant_id))) {
          
          await ShopifyCart.change({
            id: vaporisateur.key,
            quantity: 0
          });
          
          cartModified = true;
        }
      }
      
      // Rafraîchir l'interface si des modifications ont été apportées
      if (cartModified) {
        refreshCartUI();
      } else {
        removeSyncAnimation(500); // Délai pour éviter que l'animation ne disparaisse trop vite
      }
    } catch (error) {
      removeSyncAnimation(300);
    } finally {
      // Toujours débloquer les boutons et réinitialiser le flag
      isSynchronizing = false;
      unblockCheckoutButtons();
      
      // Vérifier si une autre synchronisation est nécessaire
      if (vaporisateursNeedSync) {
        scheduleSynchronization(config.minSyncInterval);
      }
    }
  }
  
  // Rafraîchir l'interface du panier
  function refreshCartUI() {
    // Déclencher les événements de mise à jour du panier
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'vaporisateur:sync'
      }
    }));
    
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    
    // Attendre que le DOM du panier soit réellement mis à jour avant de supprimer l'animation
    // On utilise un délai plus long (1500ms) pour s'assurer que les changements sont visibles
    const animationRemovalDelay = 1500;
    setTimeout(removeSyncAnimation, animationRemovalDelay);
    
    // On configure aussi un observateur pour détecter quand le contenu du panier change
    // Cela offre une meilleure synchronisation avec l'apparition du vaporisateur
    setupCartObserver();
  }
  
  // Configurer un observateur temporaire pour détecter les changements dans le panier
  let cartObserver = null;
  function setupCartObserver() {
    // Annuler tout observateur existant
    if (cartObserver) {
      cartObserver.disconnect();
    }
    
    // Observer les conteneurs du panier pour détecter l'apparition des vaporisateurs
    const cartContainers = [
      document.querySelector('.cart-drawer__content'),
      document.querySelector('.cart__items'),
      document.querySelector('.cart-items'),
      document.querySelector('[data-cart-items]'),
      document.querySelector('#CartDrawerItems'),
      document.querySelector('.mini-cart__items')
    ].filter(el => el !== null);
    
    if (cartContainers.length === 0) return;
    
    // Créer un nouvel observateur qui supprime l'animation quand le contenu change
    cartObserver = new MutationObserver((mutations) => {
      // Si on détecte un changement significatif, on supprime l'animation
      // mais avec un petit délai pour s'assurer que tout est bien chargé
      removeSyncAnimation(300);
      cartObserver.disconnect();
    });
    
    // Observer chaque conteneur trouvé
    cartContainers.forEach(container => {
      cartObserver.observe(container, { 
        childList: true, 
        subtree: true,
        characterData: true,
        attributes: true
      });
    });
    
    // S'assurer que l'observateur est déconnecté après un certain temps
    setTimeout(() => {
      if (cartObserver) {
        cartObserver.disconnect();
        cartObserver = null;
      }
    }, 3000);
  }

  // Bloquer temporairement les boutons de checkout
  function blockCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll('a[href="/checkout"], button[name="checkout"], [href*="checkout"], [onclick*="checkout"]');
    for (let i = 0; i < checkoutButtons.length; i++) {
      const button = checkoutButtons[i];
      if (!button.hasAttribute('data-original-onclick')) {
        button.setAttribute('data-original-onclick', button.getAttribute('onclick') || '');
        button.setAttribute('data-original-href', button.getAttribute('href') || '');
      }
      
      button.setAttribute('onclick', 'return false');
      button.setAttribute('href', 'javascript:void(0)');
      button.classList.add('vaporisateur-sync-in-progress');
    }
  }
  
  // Débloquer les boutons de checkout
  function unblockCheckoutButtons() {
    setTimeout(() => {
      const checkoutButtons = document.querySelectorAll('.vaporisateur-sync-in-progress');
      for (let i = 0; i < checkoutButtons.length; i++) {
        const button = checkoutButtons[i];
        const originalOnclick = button.getAttribute('data-original-onclick');
        const originalHref = button.getAttribute('data-original-href');
        
        if (originalOnclick) button.setAttribute('onclick', originalOnclick);
        if (originalHref) button.setAttribute('href', originalHref);
        
        button.classList.remove('vaporisateur-sync-in-progress');
      }
    }, config.checkoutBlockDelay);
  }

  // Planifier une synchronisation
  function scheduleSynchronization(delay = 0) {
    if (syncTimeoutId) {
      clearTimeout(syncTimeoutId);
    }
    
    syncTimeoutId = setTimeout(() => {
      synchronizeCart();
      syncTimeoutId = null;
    }, delay);
  }

  // Gestionnaire d'événement pour les ajouts au panier
  function handleProductAdded(event) {
    scheduleSynchronization(0);
  }
  
  // Gestionnaire d'événement pour les changements de panier
  function handleCartChange(event) {
    // Ne pas réagir aux événements que nous avons déclenchés nous-mêmes
    if (event.detail && event.detail.baseEvent === 'vaporisateur:sync') {
      return;
    }
    
    // NOUVEAU: Ignorer également les événements liés aux échantillons gratuits
    // Cela évite une boucle d'animation infinie lors de l'ajout/suppression d'échantillons
    if (event.detail && event.detail.baseEvent === 'sample:change') {
      return;
    }
    
    // Vérifier si l'événement concerne un échantillon gratuit
    if (event.detail && event.detail.item && 
        (event.detail.item.handle === 'echantillon-gratuit' || 
         (event.detail.item.properties && event.detail.item.properties._echantillon_gratuit === 'true'))) {
      return;
    }
    
    scheduleSynchronization(0);
  }

  // Observer les liens vers le checkout
  function observeCheckoutLinks() {
    document.body.addEventListener('click', async function(e) {
      const target = e.target.closest('a[href="/checkout"], button[name="checkout"], [href*="checkout"], [onclick*="checkout"]');
      if (!target) return;
      
      // NOUVEAU: Vérifier si le panier ne contient que des échantillons sans parfums
      const cart = await ShopifyCart.get();
      if (cart && cart.items) {
        const hasPerfume = cart.items.some(item => config.parfumsEligibles.includes(item.handle) || 
                                                 (item.product_type && item.product_type.toLowerCase().includes('parfum')));
        
        // Si le panier ne contient pas de parfums éligibles, autoriser le checkout sans validation
        if (!hasPerfume) {
          return true;
        }
      }
      
      // Cas 1: Synchronisation en cours - bloquer et attendre
      if (isSynchronizing || vaporisateursNeedSync) {
        e.preventDefault();
        e.stopPropagation();
        
        if (vaporisateursNeedSync && !isSynchronizing) {
          synchronizeCart();
        }
        
        return false;
      }
      
      // Cas 2: Vérification anti-triche avant checkout
      const isValid = await validateCartBeforeCheckout();
      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      
      // Si tout est correct, le checkout peut continuer normalement
    }, true);
  }
  
  // Masquer les éléments _sku
  let hideSkuTimeoutId = null;
  function hideSkuElements() {
    if (hideSkuTimeoutId) {
      clearTimeout(hideSkuTimeoutId);
    }
    
    hideSkuTimeoutId = setTimeout(() => {
      const elements = document.querySelectorAll('[data-cart-item-properties], [data-cart-item], .cart-item');
      processElementsBatch(elements, 0);
      hideSkuTimeoutId = null;
    }, 100);
  }
  
  // Traitement par lots des éléments DOM
  function processElementsBatch(elements, startIndex) {
    const endIndex = Math.min(startIndex + config.batchSize, elements.length);
    
    for (let i = startIndex; i < endIndex; i++) {
      const el = elements[i];
      if (el.textContent && el.textContent.includes('_sku')) {
        el.style.display = 'none';
      }
    }
    
    if (endIndex < elements.length) {
      setTimeout(() => {
        processElementsBatch(elements, endIndex);
      }, 0);
    }
  }

  // Vérifier si le panier est équilibré (nombre correct de vaporisateurs)
  async function validateCartBeforeCheckout() {
    try {
      // Obtenir l'état actuel du panier
      const cart = await ShopifyCart.get();
      if (!cart || !cart.items || cart.items.length === 0) return true;
      
      // Comptage des parfums et vaporisateurs
      const parfums = {};
      const vaporisateurs = [];
      let totalVaporisateursNeeded = 0;
      
      // Analyser le panier
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        
        if (item.handle === config.vaporisateurHandle) {
          vaporisateurs.push({
            key: item.key,
            quantity: item.quantity,
            variant_id: item.variant_id,
            variant_title: item.variant_title,
            line: i + 1,
            price: item.price,
            properties: item.properties
          });
        } else {
          // Vérifier si c'est un parfum éligible
          const variantTitle = item.variant_title || '';
          let isParfum = false;
          
          // Exclure les produits contenant 'Mist' ou 'Brume' dans leur nom (insensible à la casse)
          const productTitle = (item.product_title || '').toLowerCase();
          if (productTitle.includes('mist') || productTitle.includes('brume')) {
            continue;
          }
          
          for (let j = 0; j < config.variantSizes.length; j++) {
            if (variantTitle.includes(config.variantSizes[j])) {
              isParfum = true;
              break;
            }
          }
          
          if (isParfum) {
            const isLargeSize = variantTitle.includes('100');
            const vaporisateursNeeded = isLargeSize ? 1 : 0;
            
            if (!parfums[item.product_title]) {
              parfums[item.product_title] = {
                quantity: item.quantity,
                vaporisateursNeeded: vaporisateursNeeded * item.quantity
              };
            } else {
              parfums[item.product_title].quantity += item.quantity;
              parfums[item.product_title].vaporisateursNeeded += vaporisateursNeeded * item.quantity;
            }
            
            totalVaporisateursNeeded += vaporisateursNeeded * item.quantity;
          }
        }
      }
      
      // Calculer le nombre total de vaporisateurs
      const totalVaporisateurs = vaporisateurs.reduce((sum, v) => sum + v.quantity, 0);
      
      // NOUVEAU: Vérifier si des vaporisateurs sont présents sans parfums correspondants
      if (totalVaporisateursNeeded === 0 && totalVaporisateurs > 0) {
        // Supprimer tous les vaporisateurs
        for (const vaporisateur of vaporisateurs) {
          await ShopifyCart.change({
            id: vaporisateur.key,
            quantity: 0
          });
        }
        
        showSecurityAlert("Vaporisateurs retirés", "Les vaporisateurs gratuits ne sont disponibles qu'avec l'achat d'un parfum.");
        refreshCartUI();
        return false;
      }
      
      // Vérifier si le nombre de vaporisateurs correspond aux parfums
      if (totalVaporisateurs > totalVaporisateursNeeded) {
        // Corriger le panier avant de permettre le checkout
        await correctVaporisateurQuantities(cart, vaporisateurs, totalVaporisateursNeeded);
        return false; // Empêcher le checkout jusqu'à ce que le panier soit corrigé
      }
      
      // NOUVEAU: Vérification de l'intégrité des vaporisateurs
      let anomalieDetectee = false;
      for (const vaporisateur of vaporisateurs) {
        // Vérifier que le prix est à 0
        if (parseFloat(vaporisateur.price) !== 0) {
          anomalieDetectee = true;
          break;
        }
        
        // Vérifier que les propriétés du vaporisateur sont présentes et correctes
        if (!vaporisateur.properties || !vaporisateur.properties._vaporisateur_offert) {
          anomalieDetectee = true;
          break;
        }
      }
      
      // Si une anomalie a été détectée, resynchroniser complètement
      if (anomalieDetectee) {
        await synchronizeCart();
        showSecurityAlert("Tentative de modification détectée", "Le panier a été réinitialisé pour des raisons de sécurité.");
        return false;
      }
      
      return true; // Le panier est valide
    } catch (error) {
      return true; // En cas d'erreur, on permet quand même le checkout
    }
  }
  
  // NOUVEAU: Alerte de sécurité plus sévère
  function showSecurityAlert(title, message) {
    // Création du message
    const messageContainer = document.createElement('div');
    messageContainer.className = 'security-alert-message';
    messageContainer.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #721c24;
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      z-index: 9999;
      text-align: center;
      max-width: 300px;
      font-size: 14px;
    `;
    
    messageContainer.innerHTML = `
      <p style="font-weight: bold; margin: 0 0 8px 0;">${title}</p>
      <p style="margin: 0;">${message}</p>
      <button style="background: white; color: #721c24; border: none; padding: 5px 10px; margin-top: 12px; border-radius: 4px; cursor: pointer; font-weight: bold;">OK</button>
    `;
    
    // Ajouter au DOM
    document.body.appendChild(messageContainer);
    
    // Fermer le message au clic
    messageContainer.querySelector('button').addEventListener('click', () => {
      messageContainer.remove();
    });
    
    // Auto-fermeture après 10 secondes
    setTimeout(() => {
      if (document.body.contains(messageContainer)) {
        messageContainer.remove();
      }
    }, 10000);
  }
  
  // Corriger les quantités de vaporisateurs si nécessaire
  async function correctVaporisateurQuantities(cart, vaporisateurs, totalNeeded) {
    let remainingNeeded = totalNeeded;
    const updates = {};
    
    // Distribution équitable des vaporisateurs
    for (const vaporisateur of vaporisateurs) {
      if (remainingNeeded > 0) {
        // Garder seulement ce dont on a besoin
        const keepQuantity = Math.min(vaporisateur.quantity, remainingNeeded);
        updates[vaporisateur.key] = keepQuantity;
        remainingNeeded -= keepQuantity;
      } else {
        // Supprimer les vaporisateurs excédentaires
        updates[vaporisateur.key] = 0;
      }
    }
    
    // Appliquer les corrections
    if (Object.keys(updates).length > 0) {
      showSyncAnimation();
      await ShopifyCart.update({ updates });
      refreshCartUI();
      
      // Afficher un message d'alerte au client
      showCartCorrectionMessage();
    }
  }
  
  // Afficher un message d'alerte au client
  function showCartCorrectionMessage() {
    // Création du message
    const messageContainer = document.createElement('div');
    messageContainer.className = 'vaporisateur-correction-message';
    messageContainer.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: #f8d7da;
      color: #721c24;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      z-index: 9999;
      text-align: center;
      max-width: 300px;
      font-size: 14px;
    `;
    
    messageContainer.innerHTML = `
      <p>Votre panier a été ajusté pour correspondre au nombre correct de vaporisateurs offerts.</p>
      <button style="background: #721c24; color: white; border: none; padding: 5px 10px; margin-top: 8px; border-radius: 4px; cursor: pointer;">OK</button>
    `;
    
    // Ajouter au DOM
    document.body.appendChild(messageContainer);
    
    // Fermer le message au clic
    messageContainer.querySelector('button').addEventListener('click', () => {
      messageContainer.remove();
    });
    
    // Auto-fermeture après 8 secondes
    setTimeout(() => {
      if (document.body.contains(messageContainer)) {
        messageContainer.remove();
      }
    }, 8000);
  }

  // Initialiser le script
  function initAutoVaporisateur() {
    if (window.location.pathname.includes('/checkout')) {
      return;
    }

    // Injecter le CSS pour l'animation
    injectLoadingCSS();
    
    // Précharger le produit vaporisateur
    loadVaporisateurProduct();
    
    // Écouter les événements panier
    document.addEventListener('variant:add', handleProductAdded);
    document.addEventListener('cart:change', handleCartChange);
    
    // Observer les liens checkout
    observeCheckoutLinks();
    
    // Synchroniser le panier
    synchronizeCart();
    
    // Configurer le masquage des _sku
    hideSkuElements();
    document.addEventListener('cart:refresh', hideSkuElements);
    
    // NOUVEAU: Vérification périodique de l'intégrité du panier
    startPeriodicCartCheck();
    
    // Observer l'état du drawer-cart pour retirer l'animation si nécessaire
    document.addEventListener('cart:refresh', () => {
      
      // Réactiver l'observation des _sku après la mise à jour du panier
      setTimeout(hideSkuElements, 200);
    });
    
    // Observer les mutations DOM pour masquer les propriétés _sku
    const observer = new MutationObserver(hideSkuElements);
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });
  }
  
  // NOUVEAU: Vérification périodique du panier pour détecter les manipulations
  let cartCheckInterval = null;
  function startPeriodicCartCheck() {
    // Arrêter l'intervalle existant si présent
    if (cartCheckInterval) {
      clearInterval(cartCheckInterval);
    }
    
    // Vérifier le panier périodiquement (toutes les 17 secondes)
    cartCheckInterval = setInterval(async () => {
      // Éviter les vérifications si une synchronisation est déjà en cours
      if (isSynchronizing || document.hidden) return;
      
      try {
        const cart = await ShopifyCart.get();
        if (!cart || !cart.items || cart.items.length === 0) return;
        
        // Analyser le panier
        const parfums = [];
        const vaporisateurs = [];
        
        // Analyser les éléments du panier
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          
          if (item.handle === config.vaporisateurHandle) {
            vaporisateurs.push({
              key: item.key,
              quantity: item.quantity,
              variant_id: item.variant_id,
              variant_title: item.variant_title,
              price: item.price,
              properties: item.properties
            });
          } else {
            // Vérifier si c'est un parfum éligible
            const variantTitle = item.variant_title || '';
            let isParfum = false;
            
            // Exclure les produits contenant 'Mist' ou 'Brume' dans leur nom (insensible à la casse)
            const productTitle = (item.product_title || '').toLowerCase();
            if (productTitle.includes('mist') || productTitle.includes('brume')) {
              continue;
            }
            
            for (let j = 0; j < config.variantSizes.length; j++) {
              if (variantTitle.includes(config.variantSizes[j])) {
                isParfum = true;
                break;
              }
            }
            
            if (isParfum) {
              const isLargeSize = variantTitle.includes('100');
              const vaporisateursNeeded = isLargeSize ? 1 : 0;
              
              parfums.push({
                title: item.product_title,
                variant_title: variantTitle,
                quantity: item.quantity,
                vaporisateursNeeded: vaporisateursNeeded * item.quantity
              });
            }
          }
        }
        
        // Si des vaporisateurs sont présents, vérifier leur intégrité
        if (vaporisateurs.length > 0) {
          let needsResync = false;
          
          // Calculer combien de vaporisateurs sont nécessaires
          let totalVaporisateursNeeded = 0;
          for (const parfum of parfums) {
            totalVaporisateursNeeded += parfum.vaporisateursNeeded;
          }
          
          // Vérifier l'intégrité de chaque vaporisateur
          for (const vaporisateur of vaporisateurs) {
            // Le prix doit être à 0
            if (parseFloat(vaporisateur.price) !== 0) {
              needsResync = true;
              break;
            }
            
            // Les propriétés doivent être correctes
            if (!vaporisateur.properties || !vaporisateur.properties._vaporisateur_offert) {
              needsResync = true;
              break;
            }
          }
          
          // Vérifier le nombre total de vaporisateurs
          const totalVaporisateurs = vaporisateurs.reduce((sum, v) => sum + v.quantity, 0);
          
          // Vérifier si des vaporisateurs sont présents sans parfums
          if (totalVaporisateursNeeded === 0 && totalVaporisateurs > 0) {
            needsResync = true;
          } 
          // Vérifier si trop de vaporisateurs sont présents
          else if (totalVaporisateurs > totalVaporisateursNeeded) {
            needsResync = true;
          }
          
          // Si besoin, forcer une synchronisation
          if (needsResync) {
            synchronizeCart();
          }
        }
      } catch (error) {
        console.error(`Erreur lors de la vérification périodique:`, error);
      }
    }, 17000); // Vérification toutes les 17 secondes (valeur différente du kit pour éviter les collisions)
  }
  
  // Attendre que le DOM soit chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoVaporisateur);
  } else {
    initAutoVaporisateur();
  }
})();

